//Smooth Scroll
$('a[href*="#"]')
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function (event) {
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      let target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

      if (target.length) {
        event.preventDefault();
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        let top = 90;
        $('html, body').animate({
          scrollTop: target.offset().top - top,
        }, 500);
      }
    }
  });


// WEBPACK FOOTER //
// ./scripts/modules/_smooth-scroll.js